// extracted by mini-css-extract-plugin
module.exports = {"box":"starship_box__UQGvQ","model":"starship_model__359yM","back":"starship_back___4An4"};